import { ModuleModeEnum } from '@/enums/ModuleModeEnum';

export default {
    indicator: ({ values }: { values: { mode: ModuleModeEnum } }) => {
        const { mode } = values;

        return `표시되는 부분을 큰 소리로 읽어주세요.
                    ${mode === ModuleModeEnum.SELF ? '지문을 클릭하면 구간이 이동해요.' : ''}`;
    },
    intro: {
        content: {
            loud: '표시된 부분을 큰 소리로 읽어주세요!',
            readingType1: '{readingType}로 다함께 차근차근 읽어봐요.',
            readingType2: '{readingType}로 차근차근 읽어봐요.',
            teacherAndStudents: '선생님은 파란색, 학생은 노란색으로 표시된 부분을 큰 소리로 읽어주세요!',
            start: '{readingType}로 차근차근 읽기를 시작해 볼까요?',
            students: '{students} 친구는 표시된 부분을 큰소리로 읽어주세요!',
        },
        othersCount: '외 {count}명의',
    },
    options: {
        title: '타이틀',
        readingType: {
            label: '읽기 단위',
            unit: '단위',
            meaning: '의미',
            sentence: '문장',
            paragraph: '문단',
        },
        readingMode: {
            label: '읽기 방식',
            all: '다같이 읽기',
            split: '선생님과 나눠 읽기',
            random: '랜덤 읽기',
            selected: '지정 읽기',
        },
        example: {
            all: '모두 다 같이',
            teacher: '선생님',
            students: '학생',
        },
        textbook: '교과서에 나오는 지문',
    },
    setting: {
        readerCount: '읽을 학생 수',
        draw: '뽑기',
        redraw: '다시 뽑기',
        resetSelection: '선택 초기화',
        randomOrderNotice: 'ⓘ 순서는 랜덤으로 배정됩니다.',
        connectedCount: '접속 {count}명',
        personCount: '{count}명',
        unit: '명',
    },
    inplay: {
        reading: '읽는 중',
        readingCount: '{count}명',
        fontDown: '가 -',
        fontUp: '가 +',
        me: '나',
    },
    buttons: {
        next: '다음 학습하기',
        assign: '학생 지정하기',
        assignStudents: '학생 배정하기',
        fontSize: '글자크기',
    },
    result: {
        done: '차근차근 읽기를 완료했어요!',

        lecture: {
            all: '"{readingType} 단위"로 "전체 학생"이 읽었어요.',
            split: '"{readingType} 단위"로 "선생님"과 나눠 읽었어요.',
            random: '"{readingType} 단위"로 {students} 읽었어요.',
            selected: '"{readingType} 단위"로 {students} 읽었어요.',
            averageTime: '{time} 소요',
        },
        self: {
            all: '{readingType}로 전체 학생이 읽었어요.',
            split: '{readingType}로 선생님과 나눠 읽었어요.',
            random: '{readingType}로 {students} 읽었어요.',
            selected: '{readingType}로 {students} 읽었어요.',
            averageTime: '평균 {time} 소요',
            inplay: '"{readingType} 단위"로 "{readingMode}"를 진행중이에요.',
        },
    },

    teacherFooter: {
        done: '다 읽었어요.',
        click: '지문 영역을 클릭해 주세요.',
    },
    pageRange: '{startPage}~{endPage}쪽',
    modal: {
        random: {
            title: '돌아가며 읽기 진행 불가능',
            desc: '학생이 접속을 종료하여 "돌아가며 읽기(무작위/지정)" 진행이 불가능합니다. 진행 방식이 "전체 읽기"로 초기화되었습니다.',
        },
    },
};
